import { SVGProps } from 'react';

const X = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M8.267 3.25c.238 0 .464.114.605.307l4.445 6.063 6.153-6.15a.75.75 0 1 1 1.06 1.06l-6.314 6.315 6.388 8.712A.75.75 0 0 1 20 20.75h-4.267a.751.751 0 0 1-.605-.307L10.68 14.38 4.53 20.53a.75.75 0 1 1-1.061-1.06l6.313-6.315-6.388-8.712A.75.75 0 0 1 4 3.25h4.267Zm7.846 16h2.407l-5.852-7.981a.758.758 0 0 1-.077-.105L7.887 4.75H5.479l10.634 14.5Z"
    />
  </svg>
);

export default X;
